import { splitStringBySubstring as e } from "./helpers/splitStringBySubstring.js";
import t from "./HighlightSearch.module.js";
import { c as n } from "react/compiler-runtime";
import { Fragment as r, memo as i } from "react";
import { jsx as a } from "react/jsx-runtime";
var o = i((r) => {
	let i = n(31), o, l, u, d;
	i[0] === r ? (o = i[1], l = i[2], u = i[3], d = i[4]) : ({search: u, line: o, className: d, ...l} = r, i[0] = r, i[1] = o, i[2] = l, i[3] = u, i[4] = d);
	let f = d === void 0 ? "" : d;
	if (typeof u != "string" || typeof o != "string" || u === "") {
		let e;
		return i[5] !== f || i[6] !== o || i[7] !== l ? (e = /* @__PURE__ */ a("span", {
			...l,
			className: f,
			children: o
		}), i[5] = f, i[6] = o, i[7] = l, i[8] = e) : e = i[8], e;
	}
	let p = u.split(",").map(s).filter(Boolean), m = o.toLowerCase();
	if (p.length > 1 && p.every((e) => m.includes(e))) {
		let e;
		i[9] === o ? e = i[10] : (e = /* @__PURE__ */ a("mark", {
			className: t.mark,
			"data-test": "HighlightSearch_mark",
			children: o
		}), i[9] = o, i[10] = e);
		let n;
		return i[11] !== f || i[12] !== l || i[13] !== e ? (n = /* @__PURE__ */ a("span", {
			...l,
			className: f,
			children: e
		}), i[11] = f, i[12] = l, i[13] = e, i[14] = n) : n = i[14], n;
	}
	let h, g, _, v;
	if (i[15] !== f || i[16] !== o || i[17] !== l || i[18] !== u) {
		v = Symbol.for("react.early_return_sentinel");
		bb0: {
			let t = e(o, u);
			if (t.length === 1) {
				let e;
				i[23] !== f || i[24] !== o || i[25] !== l ? (e = /* @__PURE__ */ a("span", {
					...l,
					className: f,
					children: o
				}), i[23] = f, i[24] = o, i[25] = l, i[26] = e) : e = i[26], v = e;
				break bb0;
			}
			h = l, g = f, _ = t.map(c);
		}
		i[15] = f, i[16] = o, i[17] = l, i[18] = u, i[19] = h, i[20] = g, i[21] = _, i[22] = v;
	} else h = i[19], g = i[20], _ = i[21], v = i[22];
	if (v !== Symbol.for("react.early_return_sentinel")) return v;
	let y;
	return i[27] !== h || i[28] !== g || i[29] !== _ ? (y = /* @__PURE__ */ a("span", {
		...h,
		className: g,
		children: _
	}), i[27] = h, i[28] = g, i[29] = _, i[30] = y) : y = i[30], y;
});
function s(e) {
	return e.trim().toLowerCase();
}
function c(e, n) {
	return n % 2 == 0 ? e === "" ? null : /* @__PURE__ */ a(r, { children: e }, `${n}-${e}`) : /* @__PURE__ */ a("mark", {
		className: t.mark,
		"data-test": "HighlightSearch_mark",
		children: e
	}, `${n}-${e}`);
}
//#endregion
export { o as HighlightSearch };
